import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UserRegisterDialogComponent } from './user-register-dialog/user-register-dialog.component';
import { UserEditDialogComponent } from './user-edit-dialog/user-edit-dialog.component';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
    // ▼ 変更: user_name -> email
    displayedColumns: string[] = ['id', 'name', 'email', 'authority', 'actions'];
    dataSource: any[] = [];

    constructor(
        private authService: AuthService,
        private snackBar: MatSnackBar,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.loadUsers();
    }

    loadUsers(): void {
        this.authService.getAllUsers().subscribe({
            next: (users) => {
                this.dataSource = users;
            },
            error: (err) => {
                console.error('Failed to load users', err);
                if (err.status === 403) {
                    this.snackBar.open('You do not have permission to view users.', 'Close', { duration: 3000 });
                }
            }
        });
    }

    openRegisterDialog(): void {
        const dialogRef = this.dialog.open(UserRegisterDialogComponent, {
            width: '400px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadUsers();
            }
        });
    }

    openEditDialog(user: any): void {
        const dialogRef = this.dialog.open(UserEditDialogComponent, {
            width: '400px',
            data: user
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadUsers();
            }
        });
    }

    deleteUser(user: any): void {
        if (!confirm(`本当にユーザー "${user.name}" を削除しますか？`)) {
            return;
        }

        this.authService.deleteUser(user.id).subscribe({
            next: () => {
                this.snackBar.open('ユーザーを削除しました', 'Close', { duration: 3000 });
                this.loadUsers();
            },
            error: (err) => {
                console.error('Failed to delete user', err);
                this.snackBar.open(err.error.detail || '削除に失敗しました', 'Close', { duration: 3000 });
            }
        });
    }
}